<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour severe"></div>
          <div class="damage-label">Severe</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour major"></div>
          <div class="damage-label">Major</div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="damage-key">
          <div class="colour minor"></div>
          <div class="damage-label">Minor</div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center">
      <left
        v-on:updated="updateLeftDamage"
        :front="form.car.leftFront"
        :frontDoor="form.car.leftFrontDoor"
        :rearDoor="form.car.leftRearDoor"
        :rear="form.car.leftRear"
        :frontWheel="form.car.leftFrontWheel"
        :rearWheel="form.car.leftRearWheel"
      ></left>
    </div>
    <div class="col-12 main-images">
      <rear
        v-on:updated="updateRearDamage"
        :bumper="form.car.rearBumper"
        :boot="form.car.rearBoot"
      ></rear>
      <roof
        v-on:updated="updateRoofDamage"
        :rearWindscreen="form.car.rearWindscreen"
        :roof="form.car.roof"
        :frontWindscreen="form.car.frontWindscreen"
        :bonnet="form.car.topBonnet"
      ></roof>
      <front
        v-on:updated="updateFrontDamage"
        :bumper="form.car.frontBumper"
        :bonnet="form.car.frontBonnet"
      ></front>
    </div>
    <div class="col-12 text-center">
      <right
        v-on:updated="updateRightDamage"
        :front="form.car.rightFront"
        :frontDoor="form.car.rightFrontDoor"
        :rearDoor="form.car.rightRearDoor"
        :rear="form.car.rightRear"
        :frontWheel="form.car.rightFrontWheel"
        :rearWheel="form.car.rightRearWheel"
      ></right>
    </div>
  </div>
</template>

<script>
import Rear from './Car/Rear.vue';
import Roof from './Car/Roof.vue';
import Front from './Car/Front.vue';
import Left from './Car/Left.vue';
import Right from './Car/Right.vue';

export default {
  components: {
    Rear,
    Roof,
    Left,
    Right,
    Front
  },

  data() {
    return {
      form: {
        car: {
          car: {
            rearBumper: 0,
            rearBoot: 0,
            rearWindscreen: 0,
            roof: 0,
            frontWindscreen: 0,
            topBonnet: 0,
            frontBumper: 0,
            frontBonnet: 0,
            leftFrontDoor: 0,
            leftFront: 0,
            leftRearDoor: 0,
            leftRear: 0,
            leftRearWheel: 0,
            leftFrontWheel: 0,
            rightFrontDoor: 0,
            rightFront: 0,
            rightRearDoor: 0,
            rightRear: 0,
            rightFrontWheel: 0,
            rightRearWheel: 0
          }
        }
      }
    };
  },

  props: {
    step: Object
  },

  methods: {
    updateFrontDamage(value) {
      let refined = {
        frontBumper: value.bumper,
        frontBonnet: value.bonnet
      };

      this.updateCar(refined);
    },

    updateRightDamage(value) {
      let refined = {
        rightFrontDoor: value.frontDoor,
        rightFront: value.frontBumper,
        rightRearDoor: value.backDoor,
        rightRear: value.rearBumper,
        rightFrontWheel: value.frontWheel,
        rightRearWheel: value.rearWheel
      };

      this.updateCar(refined);
    },

    updateLeftDamage(value) {
      let refined = {
        leftFrontDoor: value.frontDoor,
        leftFront: value.frontBumper,
        leftRearDoor: value.backDoor,
        leftRear: value.rearBumper,
        leftFrontWheel: value.frontWheel,
        leftRearWheel: value.rearWheel
      };

      this.updateCar(refined);
    },

    updateRoofDamage(value) {
      let refined = {
        rearWindscreen: value.rearWindscreen,
        roof: value.roof,
        frontWindscreen: value.frontWindscreen,
        topBonnet: value.bonnet
      };

      this.updateCar(refined);
    },

    updateRearDamage(value) {
      let refined = {
        rearBumper: value.bumper,
        rearBoot: value.boot
      };

      this.updateCar(refined);
    },

    updateCar(data) {
      for (let property in data) {
        if (this.form.car.car[property]) {
          this.form.car.car[property] = data[property];
        }
      }
      this.$emit('damage-updated', this.form.car.car);
    }
  }
};
</script>
